import { addDoc, collection, doc, onSnapshot, orderBy, query, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore';
import { firestore } from '../firebase';
import { QUICK_WORK_CATEGORIES } from './quickWorkService';

const ref = collection(firestore, 'quickWorkCategories');
export function subscribeQuickWorkCategories(onData, onError) {
  return onSnapshot(query(ref, orderBy('displayOrder', 'asc')), (snapshot) => {
    const rows = snapshot.docs.map((item) => ({ id: item.id, ...item.data() }));
    if (rows.length) {
      const customNames = new Set(rows.map((row) => String(row.name || '').trim().toLowerCase()));
      const managedDefaultIndexes = new Set(rows.filter((row) => row.systemDefault === true || String(row.id || '').startsWith('default_')).map((row) => Number(String(row.id || '').replace('default_',''))));
      const missingDefaults = QUICK_WORK_CATEGORIES
        .map((name,index)=>({ id:`default-${index}`, name, isActive:true, displayOrder:index+1, isDefault:true, defaultIndex:index }))
        .filter((row)=>!managedDefaultIndexes.has(row.defaultIndex) && !customNames.has(row.name.toLowerCase()));
      onData([...rows, ...missingDefaults]);
    } else {
      onData(QUICK_WORK_CATEGORIES.map((name,index)=>({ id:`default-${index}`, name, isActive:true, displayOrder:index+1, isDefault:true })));
    }
  }, onError);
}
export async function addQuickWorkCategory(values, userId) {
  const created = await addDoc(ref, { name: values.name.trim(), isActive: true, displayOrder: Number(values.displayOrder || 999), createdAt: serverTimestamp(), createdById: userId || '' });
  return { id: created.id, name: values.name.trim(), isActive: true, displayOrder: Number(values.displayOrder || 999) };
}
export async function updateQuickWorkCategory(id, values, userId) {
  const payload = { name: values.name.trim(), isActive: values.isActive !== false, displayOrder: Number(values.displayOrder || 999), updatedAt: serverTimestamp(), updatedById: userId || '' };
  if (String(id).startsWith('default-')) {
    const stableId = `default_${String(id).replace('default-','')}`;
    await setDoc(doc(firestore, 'quickWorkCategories', stableId), { ...payload, createdAt: serverTimestamp(), createdById: userId || '', systemDefault: true }, { merge: true });
    return { id: stableId, ...payload, isDefault: false };
  }
  await updateDoc(doc(firestore, 'quickWorkCategories', id), payload);
  return { id, ...payload, isDefault: false };
}
